import { Cell, flexRender } from "@tanstack/react-table";
import { cn } from "../../lib/utils";

type TableCellProps = {
	cell: Cell<any, any>;
	noTruncate?: boolean;
	centerItems?: boolean;
};

export const TableCell = ({ cell, noTruncate, centerItems }: TableCellProps) => {
	return (
		<div
			className={cn(
				"h-full flex items-center px-[15px] [&:nth-last-child(1)]:flex-1",
				centerItems ? "justify-center" : "justify-start",
				cell.column.id === "expand" ? "px-[10px]" : "",
			)}
			style={{ width: cell.column.getSize(), minWidth: cell.column.getSize() }}
		>
			<div className={cn(!noTruncate ? "truncate" : undefined)}>
				{flexRender(cell.column.columnDef.cell, cell.getContext())}
			</div>
		</div>
	);
};
